/**
 * External dependencies
 */
//import jwt from 'jsonwebtoken';
import cubejs from "@cubejs-client/core";

/**
 * Internal dependencies
 */
import userFactory from "lib/user";
import config from "config";

let _user = userFactory();
let data = _user.getData();
let _cjs = null;

// this needs to be refactored to a factory
// if data is not set at the time this file is loaded, then it wont work
if (data && !_cjs) {
  let cubejsToken = localStorage.getItem("currentUserCubeJSToken");
  _cjs = cubejs(cubejsToken, {
    apiUrl: config("cubeJsProxy"),
  });
}

export default _cjs;
